import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useStoreActions } from "easy-peasy";
import { signInWithMicrosoftPopup } from "../lib/microsoft-oauth";
import { authenticateWithMicrosoft } from "../api/microsoft-auth";

export const SignInWithMicrosoft = () => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const setIsAuthenticated = useStoreActions(
    (actions) => actions.setIsAuthenticated
  );

  const handleSignIn = async () => {
    try {
      setIsLoading(true);

      const { code, codeVerifier } = await signInWithMicrosoftPopup();
      await authenticateWithMicrosoft({ code, codeVerifier });

      setIsAuthenticated(true);
      history.push("/applications");
    } catch (error) {
      console.error("Microsoft sign-in error:", error);

      if (error.response?.data?.error === "account_not_connected") {
        history.push("/account-not-connected");
      } else if (error.message === "Authentication cancelled") {
        setIsLoading(false);
      } else {
        alert(
          error.response?.data?.message ||
            error.message ||
            "Failed to sign in with Microsoft. Please try again."
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <button
      onClick={handleSignIn}
      disabled={isLoading}
      className="mb-2 w-full py-3 flex items-center justify-center bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed rounded cursor-pointer transition-all duration-200"
    >
      {isLoading ? (
        <>
          <svg
            className="animate-spin h-5 w-5 mr-3"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Signing in...
        </>
      ) : (
        <>
          <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
            <path fill="#F25022" d="M1 1h10v10H1z" />
            <path fill="#7FBA00" d="M13 1h10v10H13z" />
            <path fill="#00A4EF" d="M1 13h10v10H1z" />
            <path fill="#FFB900" d="M13 13h10v10H13z" />
          </svg>
          Sign in with Microsoft
        </>
      )}
    </button>
  );
};
